import axios from "axios";

export const getStoplightContentIdsByProject = async (id: string) => {
  return await axios.get(`https://stoplight.io/api/v1/projects/${id}/table-of-contents`)
    .then((result) => {
      return result.data.items.map((i: any) => {
        if (i.id) {
          return i.id
        }
        if (i.items && i.items.length > 0) {
          return i.items.map((i: any) => i.id)
        }
      }).filter((i: any) => i).flat()
    })
}

export const getStoplightNodeById = (projectId: string, id: string) => {
  return axios.get(`https://stoplight.io/api/v1/projects/${projectId}/nodes/${id}`)
}